import { przezmorzeApi } from "../../../api/api";
import type {
  CreateCustomerNoteTypeRequest,
  CustomerNoteType,
  CustomerNoteTypeListResponse,
  UpdateCustomerNoteTypeRequest,
} from "@przezmorze/api-types";

export type { CustomerNoteType };

export async function listCustomerNoteTypes(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<CustomerNoteTypeListResponse>("/customer-note-types", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addCustomerNoteType(name: string, abortSignal?: AbortSignal) {
  const body: CreateCustomerNoteTypeRequest = { name };
  const response = await przezmorzeApi.post<CustomerNoteType>("/customer-note-types", body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateCustomerNoteTypeName(id: string, name: string, abortSignal?: AbortSignal) {
  const body: UpdateCustomerNoteTypeRequest = { name };
  const response = await przezmorzeApi.put<CustomerNoteType>(`/customer-note-types/${id}`, body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function deleteCustomerNoteType(id: string, abortSignal?: AbortSignal) {
  await przezmorzeApi.delete<void>(`/customer-note-types/${id}`, {
    signal: abortSignal,
  });
}
